import { Howl, Howler } from 'howler';

let isMuted = !!localStorage.getItem('isMuted');

Howler.mute(isMuted);

export const music = new Howl({
  loop: true,
  autoplay: false,
  src: ['game/sounds/bg.mp3', 'game/sounds/bg.ogg'],
});

export const end = new Howl({
  autoplay: false,
  src: ['game/sounds/end.mp3', 'game/sounds/end.ogg', 'game/sounds/end.wav'],
});

export const collect = new Howl({
  autoplay: false,
  src: ['game/sounds/collect.mp3', 'game/sounds/collect.ogg', 'game/sounds/collect.wav'],
});

export const hit = new Howl({
  autoplay: false,
  src: ['game/sounds/hit.mp3', 'game/sounds/hit.ogg', 'game/sounds/hit.wav'],
});

export const jump = new Howl({
  autoplay: false,
  src: ['game/sounds/jump.mp3', 'game/sounds/jump.ogg', 'game/sounds/jump.wav'],
});

export const toggleMute = () => {
  isMuted = !isMuted;
  localStorage.setItem('isMuted', isMuted);
  Howler.mute(isMuted);
}

export const getIsMuted = () => isMuted;
